/**
 * Edit systems page
 */

// React
import React, { FC, useEffect, useState } from 'react';

// Libraries
import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';

// Components
import HeaderNavigate from 'components/HeaderNavigate';
import EditSystemItem from './EditSystemItem';
import ConfirmDeleteModal from 'components/ConfirmDeleteModal';

// Common styles
import {
  PageNavigateContainer,
  WrapperScroll,
  WrapperItems,
  ButtonUpdate,
  FormUserServices,
  WrapperServices,
} from 'styles';

// Utils
import { hostName } from 'utils/helper/common';

// Hooks
import { useEditSystems } from './useEditSystems';

// Router
import ROUTES from 'configs/route';

// Component

const EditSystemPage: FC = () => {
  const { user_id } = useParams();
  const {
    control,
    fields,
    modalConfirm,
    errors,
    handleSubmit,
    handleConfirmUpdate,
    handleCloseModalUpdate,
    handleUpdate,
    handleUsageChange,
    watch,
    fetchData,
    setValue,
  } = useEditSystems(Number(user_id));

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDataAsync = async () => {
      setLoading(true);
      try {
        await fetchData();
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchDataAsync();
  }, [fetchData]);

  return (
    <FormUserServices onSubmit={handleSubmit(handleConfirmUpdate)}>
      <HeaderNavigate
        linkHref={ROUTES.USER_INFO}
        linkText="おもたす登録者情報"
        currentText="ステータス編集"
      />

      <ConfirmDeleteModal
        open={modalConfirm}
        url={hostName}
        messages="この項目を保存して宜しいですか？"
        handleClose={handleCloseModalUpdate}
        handleConfirmDelete={() => handleUpdate(Number(user_id))}
      />
      <PageNavigateContainer>
        {fields && fields.length > 0 && (
          <WrapperScroll>
            <WrapperServices className="table-container">
              {fields.map((field: any, index) => {
                const usageValue = watch(`systems.${index}.is_used`);
                return (
                  <WrapperItems key={`${field?.id} ${index}`}>
                    <EditSystemItem
                      setValue={setValue}
                      index={index}
                      field={field}
                      control={control}
                      usageValue={usageValue}
                      errors={errors}
                      handleUsageChange={handleUsageChange}
                    />
                  </WrapperItems>
                );
              })}
            </WrapperServices>
          </WrapperScroll>
        )}
        {fields.length === 0 && !loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', padding: '10px 0' }}>
            <h3>データがありません</h3>
          </Box>
        )}
        {fields.length > 0 && (
          <Box>
            <ButtonUpdate type="submit" variant="contained">
              保存する
            </ButtonUpdate>
          </Box>
        )}
      </PageNavigateContainer>
    </FormUserServices>
  );
};

export default EditSystemPage;
